import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/angry': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM248 312c33.6 0 65.2 14.8 86.8 40.6 8.4 10.2 7.1 25.3-3.1 33.8-10.6 8.9-25.7 6.7-33.8-3-24.8-29.7-75-29.7-99.8 0-8.5 10.2-23.6 11.5-33.8 3s-11.6-23.6-3.1-33.8c21.6-25.8 53.2-40.6 86.8-40.6zM200 240c0 17.7-14.3 32.1-32 32.1s-32-14.3-32-32c0-6.2 2.2-11.7 5.3-16.6l-28.2-8.5c-12.7-3.8-19.9-17.2-16.1-29.9 3.8-12.7 17.1-20 29.9-16.1l80 24c12.7 3.8 19.9 17.2 16.1 29.9-3.1 10.4-12.7 17.1-23 17.1zM399 185.1c3.8 12.7-3.4 26.1-16.1 29.8l-28.2 8.5c3.1 4.9 5.3 10.4 5.3 16.6 0 17.7-14.3 32-32 32s-32-14.3-32-32c-10.3 0-19.9-6.7-23-17.1-3.8-12.7 3.4-26.1 16.1-29.9l80-24c12.8-3.8 26.1 3.4 29.9 16.1z'
      }
    ]
  }
})
